__turbopack_export_value__({
  "body-logo-18": "ResetButton-module-scss-module__K13x1W__body-logo-18",
  "body-text-12": "ResetButton-module-scss-module__K13x1W__body-text-12",
  "body-text-14": "ResetButton-module-scss-module__K13x1W__body-text-14",
  "body-text-16": "ResetButton-module-scss-module__K13x1W__body-text-16",
  "body-text-18": "ResetButton-module-scss-module__K13x1W__body-text-18",
  "body-text-20": "ResetButton-module-scss-module__K13x1W__body-text-20",
  "body-text-24": "ResetButton-module-scss-module__K13x1W__body-text-24",
  "body-text-24-2": "ResetButton-module-scss-module__K13x1W__body-text-24-2",
  "body-text-heading-2": "ResetButton-module-scss-module__K13x1W__body-text-heading-2",
  "body-text-heading-3": "ResetButton-module-scss-module__K13x1W__body-text-heading-3",
  "body-text-medium-14": "ResetButton-module-scss-module__K13x1W__body-text-medium-14",
  "body-text-medium-16": "ResetButton-module-scss-module__K13x1W__body-text-medium-16",
  "body-text-medium-18": "ResetButton-module-scss-module__K13x1W__body-text-medium-18",
  "body-text-medium2-18": "ResetButton-module-scss-module__K13x1W__body-text-medium2-18",
  "body-text2-14": "ResetButton-module-scss-module__K13x1W__body-text2-14",
  "body-text2-16": "ResetButton-module-scss-module__K13x1W__body-text2-16",
  "button-primary-text": "ResetButton-module-scss-module__K13x1W__button-primary-text",
  "button-text": "ResetButton-module-scss-module__K13x1W__button-text",
  "button2-text": "ResetButton-module-scss-module__K13x1W__button2-text",
  "card-shadow": "ResetButton-module-scss-module__K13x1W__card-shadow",
  "effect-menu": "ResetButton-module-scss-module__K13x1W__effect-menu",
  "header-1": "ResetButton-module-scss-module__K13x1W__header-1",
  "main-container": "ResetButton-module-scss-module__K13x1W__main-container",
  "main-footer-container": "ResetButton-module-scss-module__K13x1W__main-footer-container",
  "main-header-container": "ResetButton-module-scss-module__K13x1W__main-header-container",
  "resetButton": "ResetButton-module-scss-module__K13x1W__resetButton",
  "txt-12-bold": "ResetButton-module-scss-module__K13x1W__txt-12-bold",
  "txt-14-bold": "ResetButton-module-scss-module__K13x1W__txt-14-bold",
  "txt-14-bold-caps": "ResetButton-module-scss-module__K13x1W__txt-14-bold-caps",
  "txt-14-med": "ResetButton-module-scss-module__K13x1W__txt-14-med",
  "txt-16-bold": "ResetButton-module-scss-module__K13x1W__txt-16-bold",
  "txt-16-med": "ResetButton-module-scss-module__K13x1W__txt-16-med",
  "txt-18-bold": "ResetButton-module-scss-module__K13x1W__txt-18-bold",
  "txt-18-medium": "ResetButton-module-scss-module__K13x1W__txt-18-medium",
  "txt-18-medium-24": "ResetButton-module-scss-module__K13x1W__txt-18-medium-24",
  "txt-24-semi": "ResetButton-module-scss-module__K13x1W__txt-24-semi",
});
